// Centralized constants — Greek, uppercase, without accents

export const BRAND = "PinBoard tameiakes.gr";

export const NOTE_TYPES = [
  { value: "pickup", label: "ΠΑΡΑΛΑΒΗ", color: "#fca5a5", icon: "package" },
  { value: "task", label: "ΕΡΓΑΣΙΑ", color: "#fef08a", icon: "screwdriver" },
  { value: "order", label: "ΠΑΡΑΓΓΕΛΙΑ", color: "#bae6fd", icon: "cart" },
  { value: "communication", label: "ΕΠΙΚΟΙΝΩΝΙΑ", color: "#bbf7d0", icon: "phone" },
  { value: "repair", label: "ΕΠΙΣΚΕΥΗ", color: "#fed7aa", icon: "wrench" },
  { value: "notes", label: "ΣΗΜΕΙΩΣΕΙΣ", color: "#f3e8ff", icon: "notebook" },
];

export const TYPE_BY_VALUE = Object.fromEntries(
  NOTE_TYPES.map((t) => [t.value, t])
);

export const CHANNELS = [
  { value: "tel", label: "ΤΗΛΕΦΩΝΟ" },
  { value: "mail", label: "MAIL" },
  { value: "store", label: "ΣΤΟ ΚΑΤΑΣΤΗΜΑ" },
  { value: "client", label: "ΣΤΟΝ ΠΕΛΑΤΗ" },
];

export const PEOPLE = ["ΔΙΑΜΑΝΤΗΣ", "ΒΙΚΥ", "ΓΙΩΡΓΟΣ", "ΒΑΣΙΛΗΣ", "ΚΩΣΤΑΣ"];

// Device types — used only when category is "pickup" (ΠΑΡΑΛΑΒΗ)
export const DEVICE_TYPES = [
  "ΤΑΜΕΙΑΚΗ",
  "Η/Υ - LAPTOP",
  "ΕΚΤΥΠΩΤΗΣ",
  "ΠΟΛΥΜΗΧΑΝΗΜΑ",
  "ΖΥΓΑΡΙΑ",
  "ΠΛΑΣΤΙΚΟΠΟΙΗΤΗΣ",
  "ΤΗΛΕΦΩΝΟ",
  "ΟΘΟΝΗ",
  "ΑΛΛΟ ΕΙΔΟΣ",
];

export const TABS = [
  { value: "all", label: "ΟΛΑ" },
  ...NOTE_TYPES.map((t) => ({ value: t.value, label: t.label })),
  { value: "needs_payment", label: "ΠΡΟΣ ΧΡΕΩΣΗ" },
  { value: "completed", label: "ΕΚΤΕΛΕΣΜΕΝΑ" },
];

// Layout constants for snap-to-grid columns
export const COLUMN_WIDTH = 260;
export const COLUMN_GAP = 18;
export const NOTE_GAP = 14;
export const NOTE_HEIGHT = 280; // approximate; used for snap math only
export const NOTE_HEIGHT_MINI = 56;
export const TOP_OFFSET = 110; // px under header/tabs

// Field labels (Greek)
export const FIELD_LABELS = {
  customer: "ΠΕΛΑΤΗΣ",
  code: "ΚΩΔΙΚΟΣ / ΑΦΜ",
  phone: "ΤΗΛΕΦΩΝΟ",
  description: "ΠΕΡΙΓΡΑΦΗ",
  charge: "ΧΡΕΩΣΗ",
  delivery_date: "ΗΜΕΡΟΜΗΝΙΑ ΠΑΡΑΔΟΣΗΣ",
  contact_source: "ΠΗΓΗ ΕΠΙΚΟΙΝΩΝΙΑΣ",
  assigned_to: "ΚΑΤΑΧΩΡΗΣΗ ΑΠΟ",
};

// Days helper -> badge text
export function daysSince(iso) {
  if (!iso) return 0;
  const ms = Date.now() - new Date(iso).getTime();
  return Math.max(0, Math.floor(ms / (1000 * 60 * 60 * 24)));
}
